import React from "react";

/**
 * Wordmark logo: "protect" in #3a1f9c, "hub" in #222325.
 * `size` controls overall scale.
 */
export function Logo({ size = "md", invert = false, className = "" }) {
  const sizes = {
    sm: "text-lg",
    md: "text-2xl",
    lg: "text-4xl",
  };
  return (
    <div
      className={`flex items-center gap-2 ${className}`}
      data-testid="protect-hub-logo"
      aria-label="Protect Hub"
    >
      <LogoMark size={size === "sm" ? 24 : size === "lg" ? 40 : 30} />
      <span className={`${sizes[size]} font-bold leading-none tracking-tight`}>
        <span style={{ color: "#3a1f9c" }}>protect</span>
        <span style={{ color: invert ? "#ffffff" : "#222325" }}>hub</span>
      </span>
    </div>
  );
}

export function LogoMark({ size = 28 }) {
  // Stylised shield with concentric eye, drawn in Rojo Vívido.
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 64 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <path
        d="M32 4 L52 12 V30 C52 44 42 54 32 60 C22 54 12 44 12 30 V12 L32 4 Z"
        stroke="#CD1212"
        strokeWidth="3"
        strokeLinejoin="round"
        fill="none"
      />
      <ellipse cx="32" cy="32" rx="14" ry="9" stroke="#CD1212" strokeWidth="2.5" fill="none" />
      <circle cx="32" cy="32" r="4.5" fill="#CD1212" />
      <circle cx="33.5" cy="30.5" r="1.2" fill="#fff" />
    </svg>
  );
}
